import React from "react";
import FooterNav from "./FooterNav";

// Styled
import {
	Foot,
	Wrapper,
	Content,
	ContentOpen,
	AnchorMedia,
} from "./Footer.styles";
import {
	EnvelopeSimpleOpen,
	WhatsappLogo,
	InstagramLogo,
	SpotifyLogo,
} from "phosphor-react";

const navTargetHome = [
	{
		nameComp: "Brands",
		linkTo: "/#brand",
	},
	{
		nameComp: "Discover",
		linkTo: "/#discover",
	},
	{
		nameComp: "Maps",
		linkTo: "/#maps",
	},
];

const navTargetMenu = [
	{
		nameComp: "Koka",
		linkTo: "/kokamenu",
	},
	{
		nameComp: "Coca",
		linkTo: "/kokamenu#cocamenu",
	},
	{
		nameComp: "Low Cost",
		linkTo: "/kokamenu#lowcostmenu",
	},
];

const anchorMediaData = [
	{
		id: "1",
		href: "mailto:muhammaddita97@gmail.com",
		comp: <EnvelopeSimpleOpen size={25} />,
	},
	{
		id: "2",
		href: "https://wa.me/+6282112229254",
		comp: <WhatsappLogo size={25} />,
	},
	{
		id: "3",
		href: "https://www.instagram.com/teras_koka",
		comp: <InstagramLogo size={25} />,
	},
	{
		id: "4",
		href: "https://open.spotify.com/show/5Mu93ZdYeuAS29JLKRx3vT",
		comp: <SpotifyLogo size={25} />,
	},
];

const Footer = () => {
	return (
		<Foot>
			<Wrapper>
				<FooterNav target="Home" navTarget={navTargetHome} />
			</Wrapper>
			<Wrapper>
				<FooterNav target="Menu" navTarget={navTargetMenu} />
			</Wrapper>
			<Wrapper>
				<h2>Open Daily</h2>
				<ContentOpen>
					<p>From 10 AM</p>
					<p>To 10 PM</p>
				</ContentOpen>
			</Wrapper>
			<Wrapper className="media-wrapper">
				<Content>
					{anchorMediaData.map(data => {
						return (
							<AnchorMedia
								href={data.href}
								key={data.id}
								target="_blank"
								rel="noopener noreferrer"
							>
								{data.comp}
							</AnchorMedia>
						);
					})}
				</Content>
				<span>© 2021 Teras Seduh Koka. All right reserved</span>
			</Wrapper>
		</Foot>
	);
};

export default Footer;
